module.exports = __webpack_public_path__ + "img/lqclzt1.e5e1b742.svg";